import { forwardRef } from 'react';
import classNames from 'classnames';

import { MaybeErrorOrDescription } from '@xemplo/input-utils';

import { useDateFieldEvent } from './hooks/use-date-field-event';
import { useDateFieldMeta } from './hooks/use-date-field-meta';
import * as S from './date-field.styles';
import { DateFieldProps } from './date-field.types';
import { DateSelector } from './date-selector';

export const DateField = forwardRef<HTMLInputElement, DateFieldProps>((props, ref) => {
  const {
    style,
    inputSize,
    inputProps,
    hasError,
    fieldWrapperId,
    selectorProps,
    maybeErrorOrDescriptionProps,
  } = useDateFieldMeta(props);
  const { onChange, onKeyDown } = useDateFieldEvent(props);
  return (
    <S.ComponentWrapper id={fieldWrapperId} style={style}>
      <S.FieldWrapper
        className={classNames(inputSize, 'no-padding-inline', { invalid: hasError })}
      >
        <S.CustomXemploInput
          {...inputProps}
          ref={ref}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
        <DateSelector {...selectorProps} />
      </S.FieldWrapper>
      <MaybeErrorOrDescription {...maybeErrorOrDescriptionProps} />
    </S.ComponentWrapper>
  );
});
